import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ClipboardList } from "lucide-react";
import { StatusPill, KindPill } from "@/components/testsessions/TestSessionsTab";

/** Sessioni Test collegate alla seduta (collegamento facoltativo, nessun dato duplicato). */
export default function TrainingTestSessionsCard({ training }) {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/test-sessions", { params: { training_id: training.id } }).then((r) => setItems(r.data || [])).catch(() => setItems([])); }, [training.id]);
  return (
    <div className="bg-white border border-zinc-200 rounded-md p-4" data-testid="training-test-sessions-card">
      <div className="font-heading font-semibold text-sm flex items-center gap-2"><ClipboardList className="w-4 h-4" />Sessioni test collegate</div>
      {items === null ? <div className="text-xs text-zinc-500 mt-2">Caricamento…</div> : items.length === 0 ? (
        <div className="text-xs text-zinc-500 mt-2" data-testid="training-test-sessions-empty">Nessuna sessione test collegata. Si collega da Atleti → Test → Sessioni.</div>
      ) : (
        <div className="mt-2 divide-y divide-zinc-100">
          {items.map((s) => (
            <button key={s.id} data-testid={`training-test-session-${s.id}`} onClick={() => nav(`/test/sessione/${s.id}`)} className="w-full flex items-center gap-3 py-2 text-sm text-left hover:bg-zinc-50">
              <span className="font-mono text-xs text-zinc-500">{s.code}</span><span className="flex-1 truncate font-medium">{s.label}</span>
              <KindPill kind={s.kind} /><span className="text-xs text-zinc-500">{s.participants_count} atleti</span><StatusPill status={s.status} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
